export default __webpack_public_path__ + "9641d5d087bc9e626d4cb6b011f8753a.woff2";